<template>
  <div>
    <template v-for="col in myComponents">
      <el-col
        style="margin-bottom: 16px"
        v-if="['gridtable'].includes(col.type)"
        :key="col.prop"
        :span="24"
      >
        <div v-if="!$validatenull(col.label)" class="l-title">
          {{ $t(col.label) }}
        </div>
        <l-edit-table
          :required="col.required"
          :addBtnText="col.addBtnText"
          :isAddBtn="col.isAddBtn"
          :isRemoveBtn="col.isRemoveBtn"
          :isShowNum="col.isShowNum"
          :columns="getTableColumns(col.children)"
          :dataSource="formData[col.prop]"
          :filterDeleteBtn="filterTableDeleteBtn"
          :isRead="isRead"
          @addRow="handleAddRow(col)"
          @deleteRow="handleDeleteRow($event, col)"
          :ref="col.prop"
        >
          <template v-for="column in col.children" v-slot:[column.prop]="scope">
            <form-item
              :key="column.prop"
              :isRead="isRead"
              v-model="scope.row[column.prop]"
              :upCtrls="upCtrls"
              :formData="scope.row"
              :data="column"
              @change="handleItemChange($event, col, scope.$index, scope.row)"
            />
          </template>
        </l-edit-table>
      </el-col>
      <el-col
        style="margin-bottom: 16px"
        v-else-if="['viewtable'].includes(col.type)"
        :key="col.prop"
        :span="24"
      >
        <div v-if="!$validatenull(col.label)" class="l-title">
          {{ $t(col.label) }}
        </div>
        <l-view-table
          :paramFiled="formData[col.paramFiled]"
          :columns="col.columns"
          :code="col.dataCode"
        >
        </l-view-table>
      </el-col>
      <el-col
        v-else-if="col.type == 'tab'"
        :key="col.prop"
        :span="col.span"
        style="margin-bottom: 16px"
      >
        <tab-wraper :data="col" />
      </el-col>
      <el-col
        v-else-if="col.type == 'collapse'"
        :key="col.prop"
        :span="col.span"
        style="margin-bottom: 16px"
      >
        <collapse-wraper :data="col" />
      </el-col>
      <el-col v-else :key="col.prop" :span="col.span">
        <card-wraper v-if="col.type == 'card'" :data="col" />

        <form-item v-else-if="col.type == 'divider'" :data="col" />
        <el-form-item
          v-else-if="col.type == 'lable'"
          class="el-form-item-box"
          labelWidth="0px"
          :style="{ 'font-size': `${col.fontSize}px` }"
        >
          <div
            :style="{
              'text-align': col.contentPosition,
              'font-size': `${col.fontSize}px`,
              color: col.color,
              'font-weight': 'bold',
            }"
          >
            {{ $t(col.label) }}
          </div>
        </el-form-item>
        <el-form-item
          v-else-if="col.type == 'btn'"
          v-show="col.display && !isRead"
          labelWidth="0px"
        >
          <el-button
            :size="col.size"
            :plain="col.plain"
            :round="col.round"
            :circle="col.circle"
            :icon="col.myIcon"
            :type="col.myType"
            :disabled="col.disabled"
            @click="componentBtnClick(col)"
            >{{ col.label }}</el-button
          >
        </el-form-item>
        <el-form-item
          v-else
          v-show="col.display"
          :label="col.label"
          :labelWidth="col.labelWidth == undefined ? undefined : col.labelWidth + 'px'"
          :prop="col.prop"
        >
          <form-item
            v-model="formData[col.prop]"
            :isRead="isRead"
            :isPreview="isPreview"
            :isForm="true"
            :upCtrls="upCtrls"
            :data="col"
            :formData="formData"
            @change="handleItemChange"
          >
          </form-item>
        </el-form-item>
      </el-col>
    </template>
  </div>
</template>

<script>
import CardWraper from "./cardWraper.vue";
import TabWraper from "./tabWraper.vue";
import CollapseWraper from "./collapseWraper.vue";
export default {
  name: "l-form-wraper",
  inject: ["formViewer"],
  components: {
    CardWraper,
    TabWraper,
    CollapseWraper,
  },
  props: {
    myComponents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    isRead() {
      return this.formViewer.isRead;
    },
    isPreview() {
      return this.formViewer.isPreview;
    },
    upCtrls() {
      return this.formViewer.upCtrls;
    },
    formData() {
      return this.formViewer.formData;
    },
  },
  mounted() {
    for (let key in this.$refs) {
      this.formViewer.gridtableRefs[key] = this.$refs[key];
    }
  },
  methods: {
    handleItemChange(data, tableComponent, tableIndex, tableRow) {
      return this.formViewer.handleItemChange(data, tableComponent, tableIndex, tableRow);
    },
    componentBtnClick(col) {
      return this.formViewer.componentBtnClick(col);
    },

    // 编辑表格操作方法
    getTableColumns(children) {
      const columns = [];
      children.forEach((col) => {
        columns.push({
          id: col.prop,
          isHidden: !col.display,
          prop: col.prop,
          label: col.label,
          width: col.labelWidth,
          required: col.required,
          patterns: col.patterns,
        });
      });
      return columns;
    },
    handleAddRow(myTable) {
      let point = {};
      myTable.children.forEach((col) => {
        if (
          ![
            "guid",
            "createtime",
            "modifytime",
            "company",
            "department",
            "createuser",
            "modifyuser",
          ].includes(col.type)
        ) {
          point[col.prop] = col.default || undefined;
        } else {
          point[col.prop] = "";
        }

        if (!col.display) {
          switch (col.type) {
            case "":
              point[col.prop] = `learun_code_${col.code}|${this.$uuid()}`;
              break;
            case "guid":
              point[col.prop] = this.$uuid();
              break;
            case "company":
              if (this.loginInfo) {
                point[col.prop] = this.loginInfo.f_CompanyId;
              }
              break;
            case "department":
              if (this.loginInfo) {
                point[col.prop] = this.loginInfo.f_DepartmentId;
              }
              break;
            case "createuser":
              if (this.loginInfo) {
                point[col.prop] = this.loginInfo.f_UserId;
              }
              break;
            case "modifyuser":
              if (this.loginInfo) {
                point[col.prop] = this.loginInfo.f_UserId;
              }
              break;
            case "createtime":
              point[col.prop] = this.$getDayTime();
              break;
            case "modifytime":
              point[col.prop] = this.$getDayTime();
              break;
          }
        }
      });
      this.formData[myTable.prop].push(point);
    },
    handleDeleteRow(event, myTable) {
      this.formData[myTable.prop].splice(event.index, 1);
    },
    filterTableDeleteBtn(row) {
      if (row.hasNoDeleteBtn) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
